<!-- ========== Left Sidebar Start ========== -->

<ng-template #contentTemplate>

	<!--- Sidemenu -->
	<div id="sidebar-menu">
	  <!-- Left Menu Start -->
	  <ul class="list-unstyled" id="side-menu" #sideMenu>
		 <!-- {{menuItems}} -->
		 @for (item of menuItems; track $index) {
		 <ng-container>
			@if(item.isTitle){
			<li class="menu-title">{{ 'Sidebar.Menu.' + item.id | translate }}</li>
			}@else if(!item.isTitle && !item.isLayout){
			<li class="{{ item.defaultExpanded ? 'mm-active' : '' }}">
			  @if(hasItems(item)){
			  <a href="javascript:void(0);" class="is-parent" [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
				 @if(item.icon){
				 <i class="{{item.icon.substring(0,2) == 'bx' ? 'bx' : 'mdi'}} {{item.icon}}"></i>
				 }
				 <span> {{ 'Sidebar.Menu.' + item.id | translate }}</span>
				 @if(item.badge){
				 	<span class="badge bg-{{item.badge.variant}} float-end">{{ 'Sidebar.Menu.badge' | translate : { value: item.badge.text } }}</span>
				 }
			  </a>}
			  @else{
			  <a [routerLink]="item.link" class="side-nav-link-ref" routerLinkActive="active">
				 @if(item.icon){
					<i class="{{item.icon.substring(0,2) == 'bx' ? 'bx' : 'mdi'}} {{item.icon}}"></i>
				 }
				 <span> {{ 'Sidebar.Menu.' + item.id | translate }}</span>
				 @if(item.badge){
				 	<span class="badge bg-{{item.badge.variant}} float-end">{{ 'Sidebar.Menu.badge' | translate : { value: item.badge.text } }}</span>
				 }
			  </a>
			  }
			  @if(hasItems(item)){
			  <ul class="sub-menu {{ item.defaultExpanded ? 'mm-show' : 'mm-collapse' }}">
				 @for (subitem of item.subItems; track $index) {
				 <li>
					@if(hasItems(subitem)){
					<a class="side-nav-link-a-ref has-arrow" href="javascript:void(0);" [attr.data-parent]="subitem.parentId">
						cc{{ 'Sidebar.Menu.' + item.id | translate }}
					</a>
					<ul class="sub-menu">
					  @for (subSubitem of subitem.subItems; track $index) {
					  <li>
						 <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link" routerLinkActive="active" class="side-nav-link-ref">
							@if(subSubitem.icon){ <i class="{{subSubitem.icon.substring(0,2) == 'bx' ? 'bx' : 'mdi'}} {{subSubitem.icon}}"></i> }
							bb{{ 'Sidebar.Menu.' + item.id + '.' + subSubitem.id | translate }}
						 </a>
					  </li>
					  }
					</ul>}
					@else{
					<a (click)="!!layoutAction(subitem.action, $event)" [routerLink]="subitem.link" class="side-nav-link-ref cursor-pointer" [attr.data-parent]="subitem.parentId" routerLinkActive="active">
						@if(subitem.icon){ <i class="{{subitem.icon.substring(0,2) == 'bx' ? 'bx' : 'mdi'}} {{subitem.icon}}"></i> }
						{{ 'Sidebar.Menu.' + subitem.id | translate }}
					  @if(subitem.badge){
						<span class="badge bg-{{subitem.badge.variant}} float-end">
							<a preventDefault [routerLink]="subitem.badge.link" [queryParams]="subitem.badge.linkQueryParams">{{ 'Sidebar.Menu.badge' | translate : { value: subitem.badge.text } }}</a>
						</span>
					  }
					</a>
					}
				 </li>
				 }
			  </ul>
			  }
			</li>
			}
		 </ng-container>
		 }
	  </ul>
	</div>
 </ng-template>
 <!-- Sidebar -->



 <!-- ========== Left Sidebar Start ========== -->

<ng-template #condensedTemplate>

	<!--- Sidemenu -->
	<div id="sidebar-menu">
	  <!-- Left Menu Start -->
	  <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
		 <!-- {{menuItems}} -->
		 @for (item of menuItems; track $index) {
		 <ng-container>
			@if(item.isTitle){
			<li class="menu-title">{{ 'Sidebar.Menu.' + item.id | translate }}</li>
			}@else if(!item.isTitle && !item.isLayout){
			<li>
			  @if(hasItems(item)){
			  <a href="javascript:void(0);" class="is-parent" [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
				 @if(item.icon){
				 <i class="{{item.icon.substring(0,2) == 'bx' ? 'bx' : 'mdi'}} {{item.icon}}"></i>
				 }
				 <span> {{ 'Sidebar.Menu.' + item.id | translate }}</span>
				 @if(item.badge){
				 <span class="badge rounded-pill float-end bg-{{item.badge.variant}}">{{item.badge.text |
					translate}}</span>
				 }
			  </a>}
			  @else{
			  <a [routerLink]="item.link" class="side-nav-link-ref" routerLinkActive="active" [ngbTooltip]="'Sidebar.Menu.' + item.id | translate">
				 @if(item.icon){
					<i class="{{item.icon.substring(0,2) == 'bx' ? 'bx' : 'mdi'}} {{item.icon}}"></i>
				 }
				 <span> {{ 'Sidebar.Menu.' + item.id | translate }}</span>
				 @if(item.badge){
				 <span class="badge rounded-pill bg-{{item.badge.variant}} float-end">{{item.badge.text |
					translate}}</span>
				 }
			  </a>
			  }
			  @if(hasItems(item)){
			  <ul class="sub-menu" aria-expanded="false">
				 @for (subitem of item.subItems; track $index) {
				 <li>
					@if(hasItems(subitem)){
					<a class="side-nav-link-a-ref has-arrow" href="javascript:void(0);" [attr.data-parent]="subitem.parentId">
						{{ 'Sidebar.Menu.' + item.id | translate }}
					</a>
					<ul class="sub-menu mm-collapse" aria-expanded="false">
					  @for (subSubitem of subitem.subItems; track $index) {
					  <li>
						 <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link" routerLinkActive="active" class="side-nav-link-ref">
							@if(subSubitem.icon){ <i class="{{subSubitem.icon.substring(0,2) == 'bx' ? 'bx' : 'mdi'}} {{subSubitem.icon}}"></i> }
							{{ 'Sidebar.Menu.' + item.id + '.' + subSubitem.id | translate }}
						 </a>
					  </li>
					  }
					</ul>}
					@else{
					<a [routerLink]="subitem.link" (click)="!!layoutAction(subitem.action, $event)" class="side-nav-link-ref cursor-pointer" [attr.data-parent]="subitem.parentId" routerLinkActive="active" [ngbTooltip]="'Sidebar.Menu.' + subitem.id | translate">
						@if(subitem.icon){ <i class="{{subitem.icon.substring(0,2) == 'bx' ? 'bx' : 'mdi'}} {{subitem.icon}}"></i> }
					  @if(subitem.badge){
					  <span class="badge rounded-pill bg-{{subitem.badge.variant}} float-end">{{subitem.badge.text |
						 translate}}</span>
					  }
					</a>
					}
				 </li>
				 }
			  </ul>
			  }
			</li>
			}
		 </ng-container>
		 }
	  </ul>
	</div>
 </ng-template>
 
 <div class="vertical-menu">
	<ngx-simplebar class="h-100" #componentRef>
	  @if(isCondensed){
	  <div>
		 <ng-container *ngTemplateOutlet="condensedTemplate"></ng-container>
	  </div>
	  }@else {
	  <div>
		 <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
	  </div>
	  }
	</ngx-simplebar>
 </div>
 <!-- Left Sidebar End -->